export const Browsers = {
  OE: "Chrome",
  RE: "Edge",
  Pg: "Internet Explorer",
  IE: "Opera",
  kg: "Safari",
  AE: "Firefox"
};
export const OperatingSystems = {
  Fg: "Android",
  fe: "iOS",
  jg: "Mac",
  Dg: "Windows"
};
